export default "__VITE_ASSET__C2TcxS0n__"